module.exports = __webpack_public_path__ + "static/media/uk-flag.0c0715f3.svg";